import React from 'react'

const Facts = () => {
    return (
        <div className="ftcs">
            <div className="fx fxdr fxjcc fxaic">
                <div className="w50">
                    <div className="pd15"> 
                        <h1 style={{marginTop: "1.45rem"}}>Facts <span role="img" aria-label="Facts">💼</span></h1>
                        <p>Even without the knowledge of microbes and how they cause illness, silver has been used for centuries from the ancient greeks to the settlers of the australian outback and even in world war II.</p>
                    </div>
                </div>
                <div className="w50">
                    <div className="pd15">
                        <h1 style={{marginTop: "1.45rem"}}>Today <span role="img" aria-label="Vision">🗓️</span></h1>
                        <p>The use of silver continues on wide, albeit unseen, scale. Silver water purification filters are used in switzerland, silver nitrate is used in newborn baby's eyes, and silver catheters for incontinence.</p>
                    </div>
                </div>   
            </div>
        </div>
    )
}

export default Facts
